import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/teams',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'settings.users',
        },
        children: [
            {
                path: '',
                name: 'TeamList',
                component: () => import('./views/TeamList.vue'),
            },
            {
                path: 'create',
                name: 'TeamCreate',
                component: () => import('./views/TeamCreate.vue'),
                meta: {
                    moduleKey: 'settings.users',
                },
            },
            {
                path: ':id',
                name: 'TeamDetail',
                component: () => import('./views/TeamDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
